import "./_index.scss";
import 'element-matches-polyfill';
import 'nodelist-foreach-polyfill';
import "../kadence/assets/js/navigation.min";
import 'objectFitPolyfill';
import $ from "jquery";
import "./vendor/load_polyfill_ie11CustomProperties.js";

document.addEventListener('lazybeforeunveil', function(){
    // Refresh pollyfill after Autoptimize lazy load of images.
    window.objectFitPolyfill();
});


function emptyMainNavLinks() {
    $('.menu-item a').each(function () {
        var el = $(this);
        if (el.attr('href') === '' || el.attr('href') === '#' ) {
            el.on('click', function (e) {
                e.preventDefault();
            });
        }
    });
}

$(document).ready(function() {
    if(navigator.userAgent.match(/Trident.*rv:11\./)) {
        $('body').addClass('ie11');
        cssVars({
            // Targets
            rootElement: document,
            shadowDOM: false,
            // Sources
            include: 'link[rel=stylesheet],style',
        });
    }
    window.objectFitPolyfill();
    emptyMainNavLinks();
});
